import * as React from "react";
import * as UserModule from "Modules/UserModule";
import { connect } from "react-redux";
import NewContactDataForm from "./Forms/NewContactDataForm";
import { RootState } from "src/Store/Reducers/_RootReducer";
import * as H from "history";

type DispatchedP = {
  addNewContact: (data: any) => void;
};
type ConnectedP = {
  router: any;
};
type PropsLocation = {
  location?: H.Location;
};

class NewContactData extends React.Component<DispatchedP & ConnectedP & PropsLocation, any> {
  constructor(props: DispatchedP & ConnectedP & PropsLocation) {
    super(props);
  }

  public render() {
    return (
      <div className="newContactData">
        <div className="newContactData__inner">
          <NewContactDataForm
            onSubmit={async (data) => {
              // data["salesmanCode"] = this.props.router.location.search.split("=")[1];
              await this.props.addNewContact(data);
            }}
          />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps: DispatchedP = {
  addNewContact: (data: any) => UserModule.Actions.addNewContact(data),
};

function mapStateToProps(state: RootState): ConnectedP {
  return {
    router: state.router,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewContactData);



// WEBPACK FOOTER //
// ./src/components/NewContactData.tsx